import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/TableRow.scss';

export default function TableRow({
    children,
    className,
    type,
    ...props
}) {
    const classes = classNames(styles[type], className);
    return (
        <div {...props} className={classes}>
            {children}
        </div>
    );
}

TableRow.defaultProps = {
    type: 'body',
};

TableRow.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    type: PropTypes.oneOf(['header', 'body', 'footer']).isRequired,
};
